<template>
  <div style="padding:15px">
    <echarts ref="detailRef" />
  </div>
</template>
<script>
import echarts from "@/components/echarts";
export default {
  components: {
    echarts
  },
};
</script>